import { Person } from "../../models/Person";
import { LifvsUser, UserOrder } from "../../models/User";

export const REQUEST_ADMINS = "REQUEST_ADMINS";
export const REQUEST_USERS = "REQUEST_USERS";
export const REQUEST_USER_ORDERS = "REQUEST_USER_ORDERS";

export interface FetchAdmins {
  type: typeof REQUEST_ADMINS;
  payload: ReadonlyArray<Person>;
}

export interface FetchUsers {
  type: typeof REQUEST_USERS;
  payload: ReadonlyArray<LifvsUser>;
}

export interface FetchOrders {
  type: typeof REQUEST_USER_ORDERS;
  payload: ReadonlyArray<UserOrder>;
}

export interface UserState {
  isLoading: boolean;
  admins: ReadonlyArray<Person>;
  users: ReadonlyArray<LifvsUser>;
}

export interface UserOrdersState {
  userOrders: ReadonlyArray<UserOrder>;
}

export type UserActionTypes = FetchAdmins | FetchUsers | FetchOrders;
